import spiderman from '@/spiderman/index';

const { axios, api } = spiderman;

async function verify(member, {
  twid, mobile, birthdate, bindingCode,
}) {
  return (
    await axios.put(
      api.membership,
      {
        clinic: member.info.clinic,
        twid,
        mobile,
        birthdate,
        bindingCode,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      },
    )
  ).data;
}

export default {
  verify,
};
